import React from "react";
import "../../App.css";
import "./Program.css";
import Slide from "react-reveal/Slide";

export const Program = () => {
	return (
		<section className="program_wrapper container-fluid">
			<div className=" container ">
				<div className="content m-auto w-75">
					<Slide up>
						<h2>Real result from Lacuna venture</h2>
						<p>
							Lacuna Venture startup workshop introduces you to
							the entrepreneurial world and provides hands on
							sustaining your startup ideas. Entrepreneurs develop
							confidence, creativity, and possess the necessary
							skills to build sustainable startups. These programs
							offer leadership opportunities for senior leaders
							who are already experts or willing entrepreneurs
							with strong interpersonal relationships. Willing
							entrepreneurs learn from professional mentors about
							how to make it into corporate leadership positions
							across multiple industries.
						</p>
						<button className="btn btn-pri">
							Go to Program
						</button>
					</Slide>
				</div>
			</div>
		</section>
	);
};
